<template>
  <table :class="tableClass">
    <thead v-show="showHeader" :style="headerStyle">
      <th v-if="withCheckboxes" >
        <input type="checkbox"
               @click.prevent.stop="rows.forEach(function(row){$emit('checkColumnClicked',row,$event.target.checked)})"
               :checked="selectedRows.length>0"
        >
      </th>
      <th v-if="withDetailRow">
      </th>
      <th  v-for="(col,colIndex) in columns" :style="col.headerStyle" :key="colIndex" @click="$emit('headerClicked',col)">
        <vue-json-layout v-if="col.headerLayout" :layout="col.headerLayout" :model="modelForColumnLayout" :init-data="{colData:col}" :key="`${colIndex}-${col.id||col.path||''}`"></vue-json-layout>
        <vue-json-layout2 v-if="col.headerLayout2" :layout="col.headerLayout2" :external-data="{colData:col}" :key="`${colIndex}-${col.id||col.path||''}`"></vue-json-layout2>
        <div  v-else style="display:flex;align-items: center">
          <span>{{col.title}}</span>
          <span v-if="col.sortable" class="ui icon" style="margin-left:auto;">
                <i :class="{sort:true,ascending:isAscending(col),descending:isAscending(col)==false,icon:true}" :style="isAscending(col)==undefined?'color:lightgrey;opacity:0.5':''"></i>
          </span>
        </div>
      </th>
    </thead>
    <tbody :style="bodyStyle">
        <template v-for="(row,rowIndex) in rows" >
          <tr :key="rowIndex" @click="$emit('rowClicked',row)" :class="{active : isSelected(row)&&!withCheckboxes}" :style="isFunction(rowStyle)?rowStyle(row,rowIndex):rowStyle">
            <td v-if="withCheckboxes">
              <input type="checkbox"
                     @click.prevent.stop="$emit('checkColumnClicked',row,$event.target.checked)"
                     :checked="isSelected(row)">
            </td>
            <td v-if="withDetailRow">
              <div class="ui tiny icon button basic" style="box-shadow:none !important;" @click.prevent.stop="$emit('expandRow',row)">
                <i :class="{angle:true,icon:true,down:isExpanded(row),right:!isExpanded(row)}"></i>
              </div>
            </td>
            <td v-for="(col,colIndex) in columns" :style="isFunction(colStyle)?colStyle(col,colIndex,row,rowIndex):colStyle" :key="colIndex" @click="$emit('columnClicked',col,row)" >
              <vue-json-layout v-if="col.layout||col.layout$" :layout="col.layout||col.layout$" :model="modelForColumnLayout" :init-data="{rowData:row,colData:col}" :key="`${rowIndex}-${colIndex}-${col.id||col.path||''}`"></vue-json-layout>
              <vue-json-layout2 v-else-if="col.layout2" :layout="col.layout2" :external-data="{rowData:row,colData:col}" :key="`${rowIndex}-${colIndex}-${col.id||col.path||''}`"></vue-json-layout2>
              <span v-else>{{row[col.path]||''}}</span>
            </td>
            <td v-if="enableLastColumn">
              <slot name="lastColumn" :rowData="row">
                <button class="circular ui right floated icon button" @click="$emit('clickedDelRowButton',rowIndex,row)">
                  <i class="icon trash"></i>
                </button>
              </slot>
            </td>
          </tr>
          <tr v-if="isExpanded(row)" :key="`${rowIndex}-detail`" >
            <td :colspan="colspan">
              <slot name="detailRow" :rowData="row"></slot>
            </td>
          </tr>
        </template>
        <tr v-if="enableBottomRow">
          <td :colspan="colspan">
          </td>
          <td>
            <slot name="bottomBody">
              <button class="circular ui right floated icon button" @click="$emit('clickedAddRowButton')">
                <i class="icon add"></i>
              </button>
            </slot>
          </td>
        </tr>
        <tr v-if="!rows.length" style="text-align: center;">
          <td :colspan="colspan">
           <span style="color:lightgrey">{{placeholder}}</span>
          </td>
        </tr>
    </tbody>

  </table>
</template>

<script>
  import {isEqual,isMatch,pick,keys,isFunction} from 'lodash'
    export default {
      name: "control-table",
      props:{
        placeholder:{
          type:String,
          default:"Нет данных"
        },
        withDetailRow:{
          type:Boolean,
          default:false
        },
        withCheckboxes:{
          type:Boolean,
          default:false
        },
        headerStyle:{
          type:String,
          default:""
        },
        tableClass:{
          type:String,
          default:"ui very basic table "
        },
        bodyStyle:{
          type:String,
          default:""
        },
        rowStyle:{
          type:[String,Function],
          default:""
        },
        colStyle:{
          type:[String,Function],
          default:""
        },
        showHeader:{
          type:Boolean,
          default:true
        },
        rows:{
          type:Array,
          default:()=>[]
        },
        columns:{
          type:Array,
          default:()=>[]
        },
        modelForColumnLayout:{
          type:Object,
          default:()=>{
            return {}
          }
        },
        selectedRows:{
          type:Array,
          default:()=>[]
        },
        enableBottomRow:{
          type:Boolean,
          default:false,
        },
        enableLastColumn:{
          type:Boolean,
          default:false,
        },
        expandedRow:{
          type:Object,
        },
        sortAscending:{
          type:Object,
          default:()=>{return {}},
        }
      },
      computed:{
        colspan(){
          return this.columns.length+(this.withDetailRow?1:0)+(this.withCheckboxes?1:0);
        }
      },
      methods:{
        isSelected(row){
          return this.selectedRows.some(selectedRow=>this.isEqualRows(row,selectedRow))
        },
        isExpanded(row){
          return this.expandedRow?this.isEqualRows(row,this.expandedRow):false
        },
        isEqualRows(row1,row2){
          return isMatch(row1,row2)|| isMatch(row2,row1);
        },
        isAscending(col){
          return this.sortAscending[col.path];
        },
        isFunction:isFunction


      }
    }
</script>

<style scoped>

</style>
